module.exports = __webpack_public_path__ + "static/media/logo174.f542467a.png";